// extracted by mini-css-extract-plugin
export default {"wrap":"CourierInterlocking_wrap__Cj9oS","label":"CourierInterlocking_label__LM9Zz","switch":"CourierInterlocking_switch__UTKEL"};